// Validated form view

'use strict';

var _ = require('underscore'),
  Backbone = require('backbone'),
  $ = require('jquery'),
  config = require('../../js/config');


var FormView = Backbone.View.extend({

  initialize: function(options) {
    if (!this.$el.length) {
      return;
    }

    _.bindAll(this, 'validateField', 'validateForm', 'onInvalid', 'highlight', 'unhighlight');

    this.validator = this.$el.validate({
      debug: false,
      errorClass: config.classes.isInvalid,
      validClass: config.classes.isValid,
      errorElement: 'span',
      highlight: options.highlight || this.highlight,
      unhighlight: options.unhighlight || this.unhighlight,
      errorPlacement: options.errorPlacement || this.placeError,
      invalidHandler: options.invalidHandler || this.onInvalid
    });

    this.$errorBox = this.$('.u-form-errorBox');

    this.$('.Form-input').on('blur', this.validateField);
    this.$('input[type=submit]').on('click', this.validateForm);
  },

  validateField: function(e) {
    this.validator.element(e.target);
  },

  validateForm: function() {
    this.validator.form();
  },

  // Additional if invalid form
  onInvalid: function(event, validator) {
    var errors = validator.numberOfInvalids();
    if (errors) {
      this.listErrors(validator.errorList);
      this.$errorBox.addClass(config.classes.isVisible);
    } else {
      this.hideErrorBox();
    }
  },

  hideErrorBox: function() {
    this.$errorBox.removeClass(config.classes.isVisible);
  },

  listErrors: function(errorList) {
    // Error object syntax from the validator
    // {
    //   element: input#FirstName.is-invalid
    //   message: 'This field is required.'
    //   method:  'required'
    // }

    var $errorMessages = this.$errorBox.find('.u-form-errorBox-messages'),
      docFragment = document.createDocumentFragment();

    if (!$errorMessages.length) return;

    _.each(errorList, function(errorObj) {

      var $errorElementLabel = $(errorObj.element).siblings('label'),
        errorMessage = errorObj.message;

      if ($errorElementLabel) {
        var li = document.createElement('li');
        li.textContent = $errorElementLabel.text() + ': ' + errorMessage;
        docFragment.appendChild(li);
      }
    });

    $errorMessages.html(docFragment);
  },

  highlight: function(element, errorClass) {
    var $element = $(element);
    $element.addClass(errorClass);
    $element.siblings('label').addClass(errorClass);
  },

  unhighlight: function(element, errorClass) {
    var $element = $(element);
    $element.removeClass(errorClass);
    $element.siblings('label').removeClass(errorClass);

    if (!this.validator.numberOfInvalids()) {
      this.hideErrorBox();
    }
  },

  serializeToJson: function() {
    var serializedArray = this.$el.serializeArray(),
      serializedJson = {};

    $.map(serializedArray, function(element) {
      serializedJson[element.name] = element.value;
    });

    return JSON.stringify(serializedJson);
  },

  // Default error placement
  placeError: function(error, element) {
    error.insertAfter(element);
  },

  clearForm: function() {
    this.validator.resetForm();
  }

});

module.exports = FormView;



// WEBPACK FOOTER //
// ./assets/components/Form/FormView.js